<div mat-dialog-title>
  <h3>Voorraad aanmaken</h3>
  <h4>{{ productionJob.plantName }}</h4>
</div>

<mat-dialog-content class="dialog-content-alignment">
  <mat-form-field>
    <mat-label>Productie bednummer</mat-label>
    <mat-select [(ngModel)]="location">
      <mat-option value="B/nw">B/nw</mat-option>
      <mat-option value="E/nw">E/nw</mat-option>
      <mat-option value="N/nw">N/nw</mat-option>
      <mat-option value="G/nw">G/nw</mat-option>
      <mat-option value="Zb/nw">Zb/nw</mat-option>
      <mat-option value="Zn/nw">Zn/nw</mat-option>
    </mat-select>
  </mat-form-field>

  <mat-form-field *ngIf="productionJob.hasReservedStock">
    <input
      matInput
      type="number"
      placeholder="Gereserveerde Hoeveelheid"
      [ngModel]="productionJob.totalReservedAmount"
      [disabled]="true"
    />
  </mat-form-field>

  <mat-form-field *ngIf="productionJob.hasReservedStock">
    <input
      matInput
      type="number"
      placeholder="Ingangsmateriaal gebruikt"
      [ngModel]="inputMaterialAmount"
      (ngModelChange)="onInputAmountUsedChanged($event)"
      [attr.max]="productionJob.totalReservedAmount"
    />
  </mat-form-field>

  <mat-form-field *ngIf="productionJob.hasReservedStock">
    <input
      matInput
      type="number"
      placeholder="Ingangsmateriaal weggegooid"
      [value]="inputMaterialAmountTrashed"
      (input)="onTrashedInput($event)"
    />
  </mat-form-field>

  <mat-form-field>
    <input
      matInput
      type="number"
      placeholder="Originele Hoeveelheid"
      [ngModel]="originalAmount"
      (ngModelChange)="onOriginalAmountChanged($event)"
    />
  </mat-form-field>

  <mat-form-field>
    <input
      matInput
      placeholder="Bednummer"
      [(ngModel)]="location"
    />
  </mat-form-field>

  <mat-form-field>
    <input
      matInput
      placeholder="Opmerking"
      [(ngModel)]="remarks"
    />
  </mat-form-field>

  <mat-form-field>
    <mat-label>Productie datum</mat-label>
    <div class="date-picker-production-date">
      <input
        matInput
        [matDatepicker]="picker"
        [(ngModel)]="productionDate"
      />
      <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
      <mat-datepicker #picker></mat-datepicker>
    </div>
  </mat-form-field>
</mat-dialog-content>

<mat-dialog-actions>
  <div class="potting-production-job-button-container">
    <button [disabled]="isLoading" mat-raised-button (click)="cancel()">
      <mat-icon aria-label="Annuleren">backspace</mat-icon>
    </button>
    <button
      [disabled]="isDisabled() || isLoading"
      mat-raised-button
      color="primary"
      (click)="onSubmitClickCreateStock()"
    >
      Nu boeken
      <mat-icon>archive</mat-icon>
    </button>
    <button
      *ngIf="allowMarkingAsProduced"
      [disabled]="isLoading"
      mat-raised-button
      color="primary"
      (click)="onSubmitClickMarkAsProduced()"
    >
      Later tellen
      <mat-icon>conveyor_belt</mat-icon>
    </button>
  </div>
</mat-dialog-actions>
